import React from 'react';

function WhiteLabel() {
    return (
        <div className='pt-5 mt-5 mb-5 bg-primary-light'>

        <div className="white-label-container container bg-primary-light">
            <section className="white-label-section">
                {/* Title */}
                <div className="white-label-header">
                    <h2 className='text-primary'><span style={{ fontSize: '0.75em' }}>💼</span> What is the ComTech Gold White Label Solution?</h2>
                    <p>
                        ComTech Gold offers a powerful, ready-to-deploy <b>white label infrastructure</b> that enables businesses, financial institutions, exchanges, and FinTechs to create their <b>own branded digital gold platform.</b>
                    </p>
                </div>
                {/* Description */}
                <div className="white-label-highlight bg-primary-light">
                    <p>
                        Whether you are looking to tokenize physical gold, offer SIPs, enable gold trading, or provide redemption services,
                        our white label solution covers the full spectrum with trusted blockchain integration and secure custody.
                    </p>
                </div>
                {/* Key Features */}
                <div className="white-label-section">
                    <h3 className='text-primary'><span style={{ fontSize: '0.75em' }}>🔑</span>  Key Features</h3>
                    <div className="feature-grid">


                        <div className="card mt-4" >
                            <div className="contact_left_box bg-secondary-light">
                                <h4>Integrated Tokenization Platform</h4>
                                <p>Create and manage your own gold tokens backed 1:1 by physical gold with 999.9 purity, stored in insured vaults.</p>
                            </div>
                        </div>
                        <div className="card mt-4">
                            <div className="contact_left_box bg-secondary-light">

                                <h4>API Suite</h4>
                                <ul className='list-whitelabel'>
                                    <li>Buy/Sell orders</li>
                                    <li>SIP creation</li>
                                    <li>Real-time price feed</li>
                                    <li>Redemption & Gifting</li>
                                    <li>App integration</li>
                                </ul>
                            </div>
                        </div>
                           <div className="card mt-4">
                            <div className="contact_left_box bg-secondary-light">
                            <h4>Custody & Security</h4>
                         <ul className='list-whitelabel'>
                                    <li>Physical custody via secured vaults (with TradeFlow warrants)</li>
                                    <li>Digital custody of tokens.</li>
                                    <li> End-to-end insured assets (digital + physical)</li>
                                </ul>
                        </div>
                        </div>
                           <div className="card mt-4">
                            <div className="contact_left_box bg-secondary-light">
                            <h4>Blockchain Functionality</h4>
                            <ul className='list-whitelabel'>
                                <li>Minting and burning via multi-Sig wallets</li>
                                <li>Real-time transparency</li>
                                <li>Regulatory-compliant smart contracts</li>
                            </ul>
                        </div>
                        </div>
                           <div className="card mt-4">
                            <div className="contact_left_box bg-secondary-light">
                            <h4>OTC & Liquidity Integration</h4>
                         <ul className='list-whitelabel'>
                                    <li>Access liquidity via StoneX, Bitrue and other providers</li>
                                    <li>WL-USDT conversions</li>
                                    <li>Seamless order flow and margin wallet setup</li>
                                </ul>
                        </div>
                        </div>
                          <div className="card mt-4">
                            <div className="contact_left_box bg-secondary-light">
                            <h4>Distribution & Redemption</h4>
                            <p>Tie-ups with physical asset vendors for local or global delivery.</p>
                        </div>
                        </div>
                    </div>
                </div>
                {/* Ideal For */}
                <div className="white-label-section">
                    <h3><span style={{ fontSize: '23px' }}>🧩</span> Ideal For:</h3>
                    <div className="tag-container">
                        {['Bullion Traders', 'Exchanges', 'Fintech Startups', 'Digital Wallets', 'Wealth Management Platforms', 'Global Gold Retailers'].map((item, i) => (
                            <span key={i} className="tag">{item}</span>
                        ))}
                    </div>
                </div>
                {/* Why Choose Us */}
                <div className="white-label-section white-label-highlight bg-secondary-light">
                    <h3> <span style={{ fontSize: '23px' }}>🙌</span> Why Choose ComTech Gold White Label?</h3>
                    

                    <ul className="checklist">
               
                        <li><span style={{ fontSize: '12px' }}>✅</span> Shariah-Compliant</li>
                        <li><span style={{ fontSize: '12px' }}>✅</span>  Fully Audited & Regulated</li>
                        <li><span style={{ fontSize: '12px' }}>✅</span>  Backed by Real Physical Gold</li>
                        <li><span style={{ fontSize: '12px' }}>✅</span>  Fast Go-to-Market Setup</li>
                        <li><span style={{ fontSize: '12px' }}>✅</span>  Secure, Transparent, and Scalable</li>
                    </ul>
                    <p className='p-tag'>
                        “With ComTech Gold, our clients trust that every token equals real, vaulted gold. We help you build that trust—under your own brand.”
                    </p>
                </div>
                {/* Contact */}
                <div className="white-label-contact">
           <h3><span style={{ fontSize: '0.75em' }}>📞</span> Get Started Today</h3>
                    <p>Interested in launching your own digital gold solution?</p>
                    <p><span style={{fontSize:'15px'}}>📧 </span><strong>Reach us at:</strong> <a href="mailto: info@comtechgold.com"  className='email-whitelabel'><b>info@comtechgold.com </b></a></p>
                    <p><span style={{fontSize:'15px'}}>🌐  </span><strong>Visit:</strong> <a href="https://www.comtechgold.com" target="_blank" rel="noreferrer" style={{textDecoration:'underline', fontSize:'16px'}}>www.comtechgold.com</a></p>
                </div>
            </section>
        </div>
        </div>

    );
}
export { WhiteLabel };
